/* LUKE 20260820 v2 — CART-ONLY color thumbnail override. Strictly cart-scoped:
   rewrites ONLY the line-item <img> in the cart drawer / cart page to the chosen
   color's product image. Fail-safe (try/catch, no-op on miss). Never touches the
   PDP gallery, variant selection, or checkout. Observes ONLY cart-drawer nodes. */
(function(){
  if (window.__bbqCartColorThumb20260820) return;
  window.__bbqCartColorThumb20260820 = true;
  var mediaCache = {};
  function norm(s){ return (s||'').toLowerCase().replace(/&/g,'and').replace(/[^a-z0-9]+/g,' ').trim(); }
  async function colorMap(handle){
    if (mediaCache[handle]) return mediaCache[handle];
    try{
      var p = await (await fetch('/products/'+handle+'.js')).json();
      var map = {};
      (p.media||[]).forEach(function(m){
        var alt=m.alt||''; var src=(m.src||(m.preview_image&&m.preview_image.src)||'');
        if(!src) return;
        var suf = alt.indexOf(' - ')>-1 ? alt.split(' - ').pop().trim() : alt;
        if(suf && !map[norm(suf)]) map[norm(suf)] = src;
      });
      mediaCache[handle] = map; return map;
    }catch(e){ return {}; }
  }
  var running=false;
  async function fix(){
    if(running) return; running=true;
    try{
      var items = (await (await fetch('/cart.js')).json()).items || [];
      var rows = Array.prototype.slice.call(document.querySelectorAll(
        'cart-drawer .cart-item, .cart-drawer .cart-item, .cart-items .cart-item, tr.cart-item, .cart-item'));
      for (var i=0;i<items.length;i++){
        var it=items[i], row=rows[i]; if(!row) continue;
        var color=(it.options_with_values||[]).filter(function(o){return /colou?r/i.test(o.name);}).map(function(o){return o.value;})[0];
        if(!color) continue;
        var map=await colorMap(it.handle); var url=map[norm(color)]; if(!url) continue;
        var img=row.querySelector('img'); if(!img) continue;
        if((img.getAttribute('src')||'').indexOf(url.replace(/^https?:/,'').split('?')[0])===-1){
          img.setAttribute('src', url); img.removeAttribute('srcset');
        }
      }
    }catch(e){}
    running=false;
  }
  var t=null; function schedule(){ clearTimeout(t); t=setTimeout(fix,150); }
  // triggers: cart drawer opens / cart updates — scoped, not page-wide
  document.addEventListener('cart:refresh', schedule, true);
  document.addEventListener('click', function(e){
    var el=e.target.closest && e.target.closest('#cart-icon-bubble, a[href$="/cart"], a[href*="/cart?"], button[name="add"], .quantity__button, cart-drawer, .cart-remove-button');
    if(el) schedule();
  }, true);
  // observe ONLY the cart drawer/items container for re-renders
  function observeCart(){
    var c=document.querySelector('cart-drawer, .cart-drawer, cart-items, .cart-items');
    if(c && !c.__bbqCartObserved){ c.__bbqCartObserved=true; new MutationObserver(schedule).observe(c,{childList:true,subtree:true}); }
    return !!c;
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', function(){observeCart();schedule();});
  else { observeCart(); schedule(); }
  // in case cart-drawer hydrates late, retry wiring briefly
  var tries=0, iv=setInterval(function(){ if(observeCart()||++tries>20) clearInterval(iv); },500);
})();
